export enum HealthyRewardEvent
{
    Invalid = 0,
    FOBTKitRequested = 1,
    ColRewardSelfReported = 2,
}